import { Siren } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { pagerdutyWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  pagerdutyWeb,
  {
    PagerDutyPage: () => import('./PagerDutyPage'),
  },
  {
    icons: { Siren },
  },
);
